import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useParams, useSearchParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Errors = lazy(() =>
  import('./components/pages/Errors').then(({Errors}) => ({default: Errors})),
)

export function ErrorsPage() {
  const {status} = useParams()
  const [searchParams] = useSearchParams()

  const rldbEnabled = searchParams.get('rldb_enabled') === 'true'

  useDocumentTitle(t('Errors'))

  return (
    <Suspense>
      <Errors status={status} rldbEnabled={rldbEnabled} />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the errors module.
 */
export const errorsRoutes = [
  {
    index: true,
    element: <ErrorsPage />,
  },
]
